import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, signal, viewChild, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ErrorLogViewModel, GithubIssueViewModel, SupportTicketViewModel, SupportTicketMessageViewModel, SupportTicketFileViewModel, SupportTicketSelectItem, SupportTicketSimilarTickets, SupportTicketStatusViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { TicketsApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate } from "@angular/common";
import * as UAParser from 'ua-parser-js';
import { HttpClient } from "@angular/common/http";
// Import the CKEditor module for Angular integration
import { CKEditorComponent, CKEditorModule } from '@ckeditor/ckeditor5-angular';
// CKEditor imports
import { Editor, editorConfig } from '../../shared/ckeditor/ckeditor-config';

@Component({
  selector: 'app-ticket-view-component',
  templateUrl: './ticket-view.component.html',
  styleUrl: './tickets-view.component.css',
  standalone: false
})
export class TicketViewComponent implements OnInit, AfterViewInit {
  @ViewChild('messageContainer') messageContainer!: ElementRef;
  @ViewChild('newMessageEditor') editorComponent!: CKEditorComponent;
  @ViewChild('editMessageEditor') editMessageComponent!: CKEditorComponent;

  public pageTitle: string = 'Support Ticket';

  currentItem?: SupportTicketViewModel;

  loading: boolean = false;

  // imageAttachments?: TicketAttachmentModel[] | null = null;
  // fileAttachments?: TicketAttachmentModel[] | null = null;

  loadingNewMessage: boolean = false;
  loadingChangeStatus: boolean = false;
  loadingChangeType: boolean = false;
  loadingChangeAssigned: boolean = false;
  loadingChangePriority: boolean = false;
  loadingChangeEffort: boolean = false;

  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  attachmentModalVisible: boolean = false;
  loadingAttachment: boolean = false;
  mergeModalVisible: boolean = false;
  UnmergeModalVisible: boolean = false;
  unmergeAllRelatedTickets: boolean | null = null;
  unMergeAllChildrenTickets: boolean = false;
  SelectedRelatedTickets: any[] | null | undefined = [];
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;
  gitHubTitle?: string;
  selectedAttachmentURL?: string | null = null;
  selectedAttachmentName?: string | null | undefined = "";
  selectedAttachmentID?: number | undefined = 0;
  selectedFile?: SupportTicketFileViewModel | null | undefined = null;
  priorities: SupportTicketSelectItem[] | null | undefined = [];
  assigneeOptions: SupportTicketSelectItem[] | null | undefined = [];
  types: SupportTicketSelectItem[] | null | undefined = [];
  statuses: SupportTicketSelectItem[] | null | undefined = [];
  efforts: SupportTicketSelectItem[] | null | undefined = [];
  similiarTickets: SupportTicketSimilarTickets[] | null | undefined = [];
  similiarSearchString: string = "";
  ticketIDToOpen: number = 0;

  selectedMessage?: SupportTicketMessageViewModel;
  selectedMessageID: number | null | undefined = null;
  doEdit: boolean = false;
  editingMessageID: number | null | undefined = null;

  selectedSimiliarTicketID: number | null | undefined = null;
  includeRelatedTickets: boolean = false;

  newMessage = signal('');
  editMessage = signal('');

  public Editor = Editor;
  public editorConfig = editorConfig;
  initialNewMessage: string = '';
  adminViewOnly: boolean = false;
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: TicketsApiService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private cdref: ChangeDetectorRef
  ) {
  }

  setAdminViewOnlyLoading: boolean = false;

  ngOnInit(): void {
    this.getTicketData();
    this.apiService.GetTicketFilterDropdowns()
      .forEach(
        (result) => {
          this.priorities = result.Priorities;
          this.types = result.Types;
          this.statuses = result.Statuses;
          this.efforts = result.Efforts;
          this.assigneeOptions = result.Assignees;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });

    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);
  }

  ngAfterViewInit(): void {
    setTimeout(() => { this.scrollToBottomOfMessages() }, 3000);
  }

  scrollToBottomOfMessages(): void {
    if (this.messageContainer) {
      const element = this.messageContainer.nativeElement;
      element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' })
    }
  }

  getTicketData() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = +(params.get('ID') || '0');
      if ((!ID || isNaN(ID)) && this.currentItem != null && this.currentItem?.ID != null)
        ID = this.currentItem.ID || 0;
      if (ID > 0) {
        console.info('Loading ' + ID);
        this.apiService.Get({
          body: {
            id: ID,
            markAsRead: true
          }
        })
          .forEach(data => {
            this.loading = false;
            this.load(data);
            this.SelectedRelatedTickets = data.RelatedTickets;
            if (data.RelatedTickets && data.RelatedTickets.length > 0) {
              var related = [];
              for (var rt of data.RelatedTickets) {
                if (rt.Label?.toLowerCase().includes("main") && rt.Value != null) {
                  this.ticketIDToOpen = rt.Value;
                }
                var tik = {
                  Subject: rt.Label,
                  ID: rt.Value,
                  Selected: false
                }
                related.push(tik);
              }
              this.SelectedRelatedTickets = related;
            }
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });
      } else {
        this.router.navigate(['/tickets']);
      }
    });
  }

  doSetClosed() {
    var model = {
      id: this.currentItem?.ID,
      includeRelatedTickets: this.includeRelatedTickets
    }
    this.apiService.SetClosed({ body: model })
      .forEach(
        (result) => {
          if (result) {
            this.includeRelatedTickets = false;
            this.getTicketData();
          }
        }).catch(
          err => {
            this.includeRelatedTickets = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  doSetCritical() {
    var model = {
      id: this.currentItem?.ID
    }
    this.apiService.SetCritical({ body: model })
      .forEach(
        (result) => {
          if (result) {
            if (this.currentItem != null) {
              if (this.currentItem?.IsCritical == null || this.currentItem?.IsCritical == false)
                this.currentItem.IsCritical = true;
              else
                this.currentItem.IsCritical = false;
            }
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  doSetAssigned() {
    if (!this.currentItem)
      return;
    this.loadingChangeAssigned = true;
    this.apiService.SaveTicketAssignment({
      body: {
        id: this.currentItem.ID,
        userIDs: (this.currentItem.AssignedToUserID as number[] | undefined)
      }
    })
      .forEach(
        (result) => {
          this.loadingChangeAssigned = false;
        }).catch(
          err => {
            this.loadingChangeAssigned = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
  }
  doGetSimiliarTickets() {
    if (this.similiarSearchString.trim() == "" || this.similiarSearchString.length < 3) {
      return;
    }

    var model = {
      id: this.currentItem?.ID,
      searchString: this.similiarSearchString
    }
    this.apiService.GetSimiliarTickets({ body: model })
      .forEach(
        (result) => {
          if (result) {
            this.similiarTickets = result.sort((a, b) => {
              if (a.CreatedDate == null) {
                return -1
              }
              if (b.CreatedDate == null) {
                return -1
              }
              if (new Date(a.CreatedDate) < new Date(b.CreatedDate))
                return 1;
              else if (new Date(a.CreatedDate) > new Date(b.CreatedDate))
                return -1;
              else
                return 0;
            });
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  doOpenMergeModal() {
    this.mergeModalVisible = true;
    this.doGetSimiliarTickets();
  }

  doOpenUnmergeModal() {
    this.UnmergeModalVisible = true;
  }

  doCloseUnmergeModal() {
    this.UnmergeModalVisible = false;
    this.SelectedRelatedTickets = [];
    this.unmergeAllRelatedTickets = null;
  }

  doUnmergeTickets() {
    if (this.currentItem == null)
      return;

    this.loading = true;

    var relatedTicketIDs: number[] = [];
    for (var t of this.SelectedRelatedTickets!) {
      if (t.Selected && t.ID != null) {
        relatedTicketIDs.push(t.ID);
      }
    }
    if (relatedTicketIDs.length == 0 && this.currentItem.ParentTicketID == null) {
      this.alertService.error("Please select at least one related ticket to unmerge.");
      this.loading = false;
      return;
    }
    var model = {
      id: this.currentItem?.ID,
      relatedTicketIDs: relatedTicketIDs,
      unmergeAllTickets: this.unmergeAllRelatedTickets
    };
    this.apiService.UnmergeTickets({ body: model })
      .forEach(
        (result) => {
          if (result) {
            this.getTicketData();
            this.loading = false;
            this.SelectedRelatedTickets = [];
            this.UnmergeModalVisible = false;
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loading = false;
          });
  }

  selectAllRelatedTickets() {
    if (this.similiarTickets != null) {
      if (this.unMergeAllChildrenTickets == false) {
        for (var t of this.similiarTickets) {
          t.Selected = true;
        }
        this.unMergeAllChildrenTickets = true;
      }
      else {
        for (var t of this.similiarTickets) {
          t.Selected = true;
        }
        this.unMergeAllChildrenTickets = false;
      }
    }
  }

  selectSimiliarTicket(ticket: SupportTicketSimilarTickets) {
    this.selectedSimiliarTicketID = null;
    if (this.similiarTickets != null) {
      for (var t of this.similiarTickets) {
        t.Selected = false;
      }
    }
    ticket.Selected = true;
    if (ticket.ID != null)
      this.selectedSimiliarTicketID = ticket.ID;
  }

  filterSimiliarTickets() {
    this.doGetSimiliarTickets();
  }

  doMergeToParentTicket() {
    if (this.currentItem == null)
      return;
    if (this.selectedSimiliarTicketID == null)
      return;
    var model = {
      id: this.currentItem.ID,
      parentID: this.selectedSimiliarTicketID
    }
    this.apiService.SetParentTicket({ body: model })
      .forEach(
        (result) => {
          if (result) {
            this.mergeModalVisible = false;
            this.similiarSearchString = "";
            this.similiarTickets = [];
            this.getTicketData();
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  openTicket(e: any) {
    if (e == null || e.value == null || e.value == 0) {
      return;
    }
    const url = this.router.serializeUrl(this.router.createUrlTree(['tickets/' + e.value]));
    window.open(url, "_blank");
    this.ticketIDToOpen = 0;
  }

  doChangeType() {
    if (this.currentItem?.ID != null && this.currentItem?.SupportTicketTypeID != null) {
      var model = {
        TicketID: this.currentItem?.ID,
        ValueID: this.currentItem?.SupportTicketTypeID
      }
      this.loadingChangeType = true;
      this.apiService.SaveTicketType({ body: model })
        .forEach(
          (result) => {
            this.loadingChangeType = false;
            if (result) {
            }
          }).catch(
            err => {
              this.loadingChangeType = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }
  }

  doChangeStatus() {
    if (this.currentItem?.ID != null) {
      var model = {
        TicketID: this.currentItem?.ID,
        ValueID: this.currentItem?.SupportTicketStatusID || -1
      }
      this.loadingChangeStatus = true;
      this.apiService.SaveTicketStatus({ body: model })
        .forEach(
          (result) => {
            this.loadingChangeStatus = false;
            if (result) {
            }
          }).catch(
            err => {
              this.loadingChangeStatus = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }
  }

  doChangePriority() {
    if (this.currentItem?.ID != null && this.currentItem?.SupportTicketPriorityID != null) {
      var model = {
        TicketID: this.currentItem?.ID,
        ValueID: this.currentItem?.SupportTicketPriorityID
      }
      this.loadingChangePriority = true;
      this.apiService.SaveTicketPriority({ body: model })
        .forEach(
          (result) => {
            this.loadingChangePriority = false;
            if (result) {
            }
          }).catch(
            err => {
              this.loadingChangePriority = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }
  }

  doChangeEffort() {
    if (this.currentItem?.ID != null && this.currentItem?.SupportTicketEffortID != null) {
      var model = {
        TicketID: this.currentItem?.ID,
        ValueID: this.currentItem?.SupportTicketEffortID
      }
      this.loadingChangeEffort = true;
      this.apiService.SaveTicketEffort({ body: model })
        .forEach(
          (result) => {
            this.loadingChangeEffort = false;
            if (result) {
            }
          }).catch(
            err => {
              this.loadingChangeEffort = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }
  }

  doShowAttachment(attachment: SupportTicketFileViewModel) {
    this.selectedAttachmentName = "";


    this.selectedAttachmentName = attachment.FileName;
    this.selectedAttachmentURL = null;
    this.selectedAttachmentID = attachment.ID;
    this.selectedFile = attachment;
    this.attachmentModalVisible = true;

    if ((attachment.ImageThumbnail && attachment.ImageThumbnail.trim() !== '')
      || (this.selectedFile.FileType && this.selectedFile.FileType.startsWith('image/'))) {
      this.loadingAttachment = true;

      this.apiService.GetAttachmentURL({
        body: {
          id: this.selectedAttachmentID
        }
      })
        .forEach(
          (result) => {
            this.loadingAttachment = false;
            if (result) {
              this.selectedAttachmentURL = result;
              console.log(result);
            } else {
              // download bytes
              this.http.get(environment.webApiRoot + '/api/Tickets/GetAttachmentData?id=' + this.selectedAttachmentID,
                {
                  observe: 'response',
                  responseType: 'blob'
                })

                .forEach(
                  (data: any) => {
                    if (data) {
                      const blob = new Blob([data.body], { type: attachment.FileType || 'image/png' });
                      this.selectedAttachmentURL = URL.createObjectURL(blob);
                    }
                  }).catch(
                    err => {
                      this.alertService.error(Utils.getAjaxError(err));
                    });
            }
          }).catch(
            err => {
              this.loadingAttachment = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }

  }

  doDownloadAttachment() {

    if (this.selectedAttachmentURL != null) {
      window.open(this.selectedAttachmentURL, "_blank");
      return;
    }
    var model = {
      id: this.selectedAttachmentID
    }
    this.apiService.GetAttachmentURL({ body: model })
      .forEach(
        (result) => {
          if (result) {
            window.open(result, "_blank");
            console.log(result);
          } else {
            // download bytes
            this.http.get(environment.webApiRoot + '/api/Tickets/GetAttachmentData?id=' + this.selectedAttachmentID,
              {
                observe: 'response',
                responseType: 'blob'
              })
              //this.apiService.GetAttachmentData$Response({
              //  
              //    id: this.selectedAttachmentID
              //  })
              .forEach(
                (data: any) => {
                  if (data) {

                    let filename = this.selectedFile!.FileName || "File.png";
                    let disposition = data.headers.get('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                      var matches = filenameRegex.exec(disposition);
                      if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                    }

                    let type = data.headers.get('Content-Type') || this.selectedFile!.FileType || '';

                    let blob;
                    if (typeof File === 'function') {
                      try {
                        blob = new File([data.body], filename, { type: type });
                      } catch (e) { /* Edge */ }
                    }
                    if (typeof blob === 'undefined') {
                      blob = new Blob([data.body], { type: type });
                    }



                    // IE doesn't allow using a blob object directly as link href
                    // instead it is necessary to use msSaveOrOpenBlob
                    let winNav: any = window.navigator;
                    if (window.navigator && winNav.msSaveOrOpenBlob) {
                      winNav.msSaveOrOpenBlob(blob, filename);
                      return;
                    }
                    let URL = window.URL || (window as any).webkitURL;
                    let downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                      // use HTML5 a[download] attribute to specify filename
                      let a = document.createElement("a");
                      // safari doesn't support this yet
                      if (typeof a.download === 'undefined') {
                        window.location.href = downloadUrl;
                      } else {
                        a.href = downloadUrl;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                      }
                    } else {
                      window.location.href = downloadUrl;
                    }

                    setTimeout(function () {
                      URL.revokeObjectURL(downloadUrl);

                    }, 100); // cleanup

                  }
                }).catch(
                  err => {
                    this.alertService.error(Utils.getAjaxError(err));
                  });
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }


  isImageAttachment(file: SupportTicketFileViewModel): boolean {
    if (file.ImageThumbnail && file.ImageThumbnail.trim() !== '') {
      return true;
    }
    return false;
  }

  getAttachmentThumbnail(file: SupportTicketFileViewModel): string {
    if (file.ImageThumbnail && file.ImageThumbnail.trim() !== '') {
      const type = file.FileType && file.FileType.trim() !== ''
        ? file.FileType
        : 'image/png';

      return `data:${type};base64,${file.ImageThumbnail}`;
    }

    return '/assets/icon-navy-144.png';
  }

  modalIsImageAttachment(): boolean {
    if (this.selectedFile != null) {
      if (
        this.selectedFile.FileType && this.selectedFile.FileType.trim() !== '') {
        return this.selectedFile.FileType.startsWith('image/');
      }
      return false;
    }
    return false;
  }

  getModalAttachmentImage() {

    if (this.selectedAttachmentURL != null) {
      return this.selectedAttachmentURL;
    }
    else if (this.selectedFile && this.selectedFile.ImageThumbnail && this.selectedFile.ImageThumbnail.trim() !== '') {
      const type = this.selectedFile.FileType && this.selectedFile.FileType.trim() !== ''
        ? this.selectedFile.FileType
        : 'image/png';

      return `data:${type};base64,${this.selectedFile.ImageThumbnail}`;
    }
    else {
      return '';
    }
  }

  getModalAttachmentThumbnail() {
    if (this.selectedFile != null) {
      if (this.selectedFile.ImageThumbnail != null && this.selectedFile.ImageThumbnail != "") {
        return 'data:' + (this.selectedFile.FileType == " " || this.selectedFile.FileType == null ? 'image/png' : this.selectedFile.FileType) + ';base64,' + this.selectedFile.ImageThumbnail;
      }
      else {
        return 'assets/images/file-icon.png';
      }
    }
    else {
      return 'assets/images/file-icon.png';
    }
  }

  doSetRead() {
    var model = {
      id: this.currentItem?.ID
    }
    this.apiService.SetTicketRead({ body: model })
      .forEach(
        (result) => {
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  doSetMessageRead(message: SupportTicketMessageViewModel) {

    this.apiService.SetMessageRead({
      body: {
        id: message.ID
      }
    })
      .forEach(
        (result) => {
          if (result)
            message.DateRead = new Date().toISOString();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
    return false;
  }
  doSetPinned() {
    var model = {
      id: this.currentItem?.ID
    }
    this.apiService.SetPinned({ body: model })
      .forEach(
        (result) => {
          if (result) {
            var pinned = this.currentItem?.IsPinnedByUser == null ? false : !this.currentItem?.IsPinnedByUser
            if (this.currentItem != null)
              this.currentItem.IsPinnedByUser = pinned;
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  changeMessageAdminView(message: SupportTicketMessageViewModel) {
    if (!message) {
      return;
    }
    this.loading = true
    var model = {
      id: message.ID
    };

    this.apiService.SetMessageAdminView({ body: model })
      .forEach(
        (result) => {
          if (result) {
            setTimeout(() => { this.setMessageLoadingFalse(message) }, 2000);
          }
        }).catch(
          err => {
            this.loading = false;
            this.cdref.detectChanges();
            this.alertService.error(Utils.getAjaxError(err));
          });

  }

  setMessageLoadingFalse(message: SupportTicketMessageViewModel) {
    this.loading = false
  }

  showMessageMenu(message: SupportTicketMessageViewModel) {
    if (this.selectedMessage == message) {
      this.selectedMessage = undefined;
      this.selectedMessageID = null;
    }
    else {
      this.selectedMessage = message;
      this.selectedMessageID = message.ID;
    }
  }

  showEditMessage(message: SupportTicketMessageViewModel) {
    this.editingMessageID = message.ID;
    if (this.selectedMessage == message) {
      this.doEdit = true;
      this.editingMessageID = message.ID;
      this.selectedMessage = undefined;
      this.selectedMessageID = null;
    }
    else {
      this.doEdit = false;
      this.editingMessageID = 0;
    }
  }

  cancelEdit(message: SupportTicketMessageViewModel) {
    this.doEdit = false;
    this.editingMessageID = 0;
  }

  sendNewMessage() {
    if (this.loadingNewMessage) {
      this.alertService.info("Please wait, your previous message is still being sent.");
      return;
    }
    var model = {
      ticketID: this.currentItem?.ID,
      message: this.newMessage(),
      isAdminView: this.adminViewOnly
    }
    this.loadingNewMessage = true;
    this.apiService.SendNewMessage({ body: model })
      .forEach(
        (result) => {
          this.loadingNewMessage = false;
          if (result) {
            this.currentItem?.Messages?.push(result);
            setTimeout(() => { this.scrollToBottomOfMessages() }, 200);
            this.newMessage.set("");
            this.clearEditor();
          }
        }).catch(
          err => {
            this.loadingNewMessage = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  doEditMessage(message: SupportTicketMessageViewModel) {
    if (!message) {
      return;
    }
    var model = {
      messageID: message.ID,
      message: this.editMessage()
    }
    this.apiService.EditMessage({ body: model })
      .forEach(
        (result) => {
          if (result) {
            message.Message = result.Message;
            message.MessageHtml = result.MessageHtml;
            this.doEdit = false;
            this.editingMessageID = 0;
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  deleteMessage(id: number | undefined) {
    if (!id) {
      return;
    }
    var model = {
      messageID: id
    }
    this.apiService.DeleteMessage({ body: model })
      .forEach(
        (result) => {
          if (result) {
            if (this.currentItem != null) {
              if (this.currentItem.Messages != null && this.currentItem.Messages.length > 0) {
                this.currentItem.Messages = this.currentItem.Messages.filter(x => x.ID != id);
              }
            }
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  clearEditor() {
    if (this.editorComponent && this.editorComponent.editorInstance) {
      this.editorComponent.editorInstance.setData('');
    }
  }

  async load(data: SupportTicketViewModel) {
    this.currentItem = data;
  }

  closeTicket() {
    if (this.currentItem)
      this.currentItem.DateClosed = new Date().toISOString();
  }



  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }

  formatMountainTime(date: Date | string | undefined | null) {

    return Utils.formatMountainTime(date);
  }

  editorOnChange(event: any) {
    this.newMessage.set(event.editor.getData());
  }
  editMessageChange(event: any) {
    this.editMessage.set(event.editor.getData());
  }

  get gitHubLink() {
    if (this.currentItem?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/issues/${this.currentItem?.GitHub_IssueNumber}`;
      return url;
    }
    else return "";
  }
  get gitHubBranchLink() {
    if (this.currentItem?.GitHub_Branch) {
      var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/tree/${encodeURIComponent(this.currentItem?.GitHub_Branch)}`;
      return url;
    }
    else return "";
  }
  

  openGitHubLink() {
    if (this.currentItem?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/issues/${this.currentItem?.GitHub_IssueNumber}`;
      var w = window.open(url, '_blank');
      return;
    }
  }
  getGitLabelClass(label: any) {
    var baseClass = "text-nowrap badge rounded-pill mr-1 ";
    if (label && label.Name == 'bub')
      baseClass += 'bg-danger text-white';
    else if (label && label.Color == 'ffffff')
      baseClass += 'bg-light text-dark';
    return baseClass;
  }

  showLinkGitHub() {
    if (this.currentItem?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/issues/${this.currentItem?.GitHub_IssueNumber}`;
      var w = window.open(url);
      if (!w)
        location.href = url;
      return;
    }

    this.gitHubTitle = `Ticket-${this.currentItem?.ID}: ${this.currentItem?.Subject || ''}`;
    this.gitHubIssueVisible = true;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.gitHubIssues = [{ title: 'Create new issue', number: 0, repository: '' }];
      this.gitHubIssue = this.gitHubIssues[0];
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'Create new issue', number: 0, repository: '' });

          this.gitHubIssues = result;
          var myTitle = `Ticket-${this.currentItem?.ID}:`;
          var r = result.find(x => x.title && x.title.indexOf(myTitle) !== -1)
          if (!r)
            r = result.find(x => x.title && x.title.indexOf(this.currentItem?.Subject || '') !== -1)
          if (!r)
            r = result[0];

          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }

  }


  linkGitHub() {
    if (!this.currentItem || !this.currentItem.ID || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);


    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        IDs: [this.currentItem!.ID || 0],
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        title: this.gitHubTitle || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.currentItem!.GitHub_IssueNumber = result.number;
        this.currentItem!.GitHub_Repository = result.repository;
        
        this.alertService.success('Item linked successfully to Issue #' + result.number );

        var url = `https://github.com/UTBS/${this.currentItem?.GitHub_Repository}/issues/${this.currentItem?.GitHub_IssueNumber}`;
        var w = window.open(url);

        this.gitHubIssue = result;
        if (this.gitHubIssues && this.gitHubIssue && this.gitHubIssue.number == 0)
          this.gitHubIssues.push({ title: result.title, number: result.number, repository: result.repository });


      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }
  getOtherDetails() {
    let otherDetails: any[] = [];
    if (this.currentItem?.OtherDetails) {
      for (var item in this.currentItem.OtherDetails) {
        let label = item;
        if (label == 'IsCriticalToWork')
          label = 'Critical to Work';
        else if (label == 'FeatureDepartment')
          label = 'Feature Department';
        else if (label == 'FeatureApprovedBy')
          label = 'Approved By';
        else if (label == 'FeaturePriority')
          label = 'Requested Priority';
        otherDetails.push({
          label: label,
          value: this.currentItem.OtherDetails[item]
        });
      }

    }
    return otherDetails;
  }
}
